import { ReactSVG } from 'react-svg'

import { LocalizedLink as Link } from '@shared/lib/locale'

import styles from './styles.module.scss'

interface ArrowLinkProps {
  to: string;
  text?: string;
  onClick?: () => void;
}

export default function ArrowLink (props: ArrowLinkProps) {
  const { to, text, onClick } = props

  return (
    <Link to={to} className={styles.root} onClick={onClick}>
      {text}
      <span className={styles.icon}>
        <ReactSVG className={styles.svg} src="/icons/arrow.svg" />
      </span>
    </Link>
  )
}
